import React, { Component } from "react";
import EmployesForm from "../EmployesForm/employesForms";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : EmployesForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente Employes
================================================================================ */
class EmployePage extends Component {
    render() {
        return (
            <div>
                <EmployesForm />
            </div>
        )
    }
}

export default EmployePage;